import { InjectionToken } from '@angular/core'

export const PS_PDF_KIT_BASE_CONFIG = new InjectionToken<{
  baseUrl: string
  licenseKey: string
}>('PS_PDF_KIT_BASE_CONFIG')
